const styles = theme => ({
  container: {
  	'& .MuiPaper-root': {
    	backgroundColor: theme.palette.primary.main,
    	'& .MuiDialogTitle-root': {
    		'& h2': {
    			color: theme.palette.primary.contrastText,
    			paddingTop: 0
    		}
    	},
    	'& .MuiDialogContent-root': {
    		backgroundColor: theme.palette.primary.contrastText,
    		color: theme.palette.primary.main,
    	},
    	'& .MuiDialogActions-root': {
    		backgroundColor: theme.palette.primary.contrastText,
    	}
    }
  }
});

export default styles;
